import { makeStyles, Theme } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { MfwMobThemeType } from 'myfitworld-utils';
import { dropdownMobileTabStyle } from 'src/pages/globalPagesStyles';

interface StyleProps {
  mfwTheme?: MfwMobThemeType;
}

const useChatStyles = makeStyles<Theme, StyleProps>((theme: Theme) => {
  const rowBase: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
  };

  return {
    dialogTitle: {
      ...rowBase,
      flex: 1,
      justifyContent: 'space-between',
      zIndex: 1000,
      minHeight: '50px',
    },
    row: rowBase,
    rowSpace: {
      ...rowBase,
      justifyContent: 'space-between',
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
    },
    tab: {
      minHeight: 45,
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },
    dropdownMobileTabStyle: dropdownMobileTabStyle(theme),
    exitButton: {
      color: theme.palette.text.primary,
    },
    dateText: {
      marginBottom: theme.spacing(1),
    },
    messageText: {
      color: '#CDCDCD',
    },
    replyActivityBox: {
      padding: '2%',
      marginTop: '2%',
      borderRadius: 5,
      width: '100%',
      backgroundColor: (props) => props.mfwTheme?.primaryLight, // Using props to access mfwTheme
    },
    titleText: {
        marginTop: 7,
        marginLeft: 10
    },
    title: {
        ...rowBase,
        marginLeft: 20,
        marginTop: 10
    }
  };
});
export default useChatStyles;
